import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProtoApiService } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ListBuyersForSellerRequest } from '../../_generated/models/list-buyers-for-seller-request';
import { ListBuyersForSellerResponse } from '../../_generated/models/list-buyers-for-seller-response';

@Injectable({ providedIn: 'root' })
export class ListBuyersForSellerService extends ProtoApiService<
    ListBuyersForSellerRequest,
    ListBuyersForSellerResponse
> {
    public requestType = ListBuyersForSellerRequest;
    public responseType = ListBuyersForSellerResponse;
    public endpointName = 'ListBuyersForSeller';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
